'use client';

import type { ReactNode } from 'react';
import CustomLink from 'components/shared/CustomLink';
import styles from './FeatureLink.module.css';

function ArrowUpRight() {
  return (
    <svg
      className={styles.icon}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M4.66667 11.3333L11.3333 4.66667"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66667 4.66667H11.3333V11.3333"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FeatureLink({
  href,
  children,
}: {
  href: string;
  children: ReactNode;
}) {
  return (
    <CustomLink href={href} className={styles.link} target="_blank">
      <span className={styles.label}>{children}</span>
      <ArrowUpRight />
    </CustomLink>
  );
}
